import axios from "axios";
import { getApiContext } from "./requestAuth";

const base = (org) => {
  const { apiUrl, token } = getApiContext();
  return { url: `${apiUrl}/api/organizations/${org}/messages`,
    config: { headers: token ? { Authorization: `Bearer ${token}` } : {}, withCredentials: true } };
};
export const listMessages = async (org) => { const { url, config } = base(org); return (await axios.get(url, config)).data; };
export const listRecipients = async (org) => { const { url, config } = base(org); return (await axios.get(`${url}/recipients`, config)).data; };
export const sendMessage = async (org, recipient_key, body) => { const { url, config } = base(org); return (await axios.post(url, { recipient_key, body }, config)).data; };
export const markMessageRead = async (org, id) => { const { url, config } = base(org); return (await axios.post(`${url}/${id}/read`, {}, config)).data; };
